import React from 'react';
import { CheckIcon, GiftIcon, GlobeIcon, MonitorSmartphoneIcon, ZapIcon } from 'lucide-react';
import { bonuses, includedItems } from '../../data/content';
import { CTAButton } from '../CTAButton';
import { CountdownTimer } from '../CountdownTimer';
import { ScarcityBar } from '../ScarcityBar';
import { TransformCTA } from '../TransformCTA';
export function Offer() {
  return <section id="oferta" className="w-full bg-navy px-4 py-14 sm:py-20" data-id="element-163" data-mp="3a5gluat0k8ja">
      <div className="mx-auto max-w-2xl" data-id="element-164" data-mp="3a3clg2ubprnr">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.25em] text-brandred-light" data-id="element-165" data-mp="3f4086cbirmc6">
          🏆 Oferta especial de lanzamiento
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] leading-tight font-black tracking-tight text-white sm:text-4xl" data-id="element-166" data-mp="3jxcuugwn1j2a">
          Hoy no estás comprando información
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-white/70" data-id="element-167" data-mp="3sxrk1rcq3ib2">
          Estás accediendo a un sistema que te permite tomar decisiones clínicas con claridad,
          incluso bajo presión.
        </p>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white" data-id="element-168" data-mp="1fmna4y33gxmv">
          <div className="border-b border-navy/10 p-5 sm:p-6" data-id="element-169" data-mp="1fohqdz3f81km">
            <p className="text-[11px] font-black uppercase tracking-[0.18em] text-navy/45" data-id="element-170" data-mp="1bll520mhxrcz">
              📦 Todo lo que recibes hoy
            </p>
            <ul className="mt-4 space-y-2.5" data-id="element-171" data-mp="23byawfkg2s10">
              {includedItems.map(i => <li key={i} className="flex items-start gap-2.5" data-id="element-172" data-mp="23dskwyu6gzqb">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brandred" strokeWidth={3} data-id="element-173" data-mp="1zawbnyqj2fz1" />
                  <span className="text-[14px] leading-snug text-navy/80" data-id="element-174" data-mp="1ui35d6feuzku">{i}</span>
                </li>)}
            </ul>
          </div>

          <div className="border-b border-navy/10 bg-cream p-5 sm:p-6" data-id="element-175" data-mp="2mzozf7wzxhik">
            <p className="flex items-center gap-1.5 text-[11px] font-black uppercase tracking-[0.18em] text-brandred" data-id="element-176" data-mp="2n21mfzhm2i2h">
              <GiftIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-177" data-mp="315h96j0du60d" />+ 5 Bonos que eliminan el error en
              tiempo real
            </p>
            <ul className="mt-4 space-y-2.5" data-id="element-178" data-mp="3638wt0tzv5yr">
              {bonuses.map(b => <li key={b.title} className="flex items-start gap-2.5" data-id="element-179" data-mp="2sdypvz853a32">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brandred" strokeWidth={3} data-id="element-180" data-mp="2weint50jehq9" />
                  <span className="text-[14px] leading-snug text-navy/80" data-id="element-181" data-mp="2iezj6m6xpoip">{b.title}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col items-center p-5 sm:p-6" data-id="element-182" data-mp="2nfne3iyaapi7">
            <p className="text-[12px] font-semibold uppercase tracking-wide text-navy/45" data-id="element-183" data-mp="29f2zz03bdhv1">
              Valor total del sistema
            </p>
            <p className="font-display text-2xl font-black text-navy/40 line-through" data-id="element-184" data-mp="2dhza02esg5nd">$194 USD</p>

            <p className="mt-4 text-[12px] font-black uppercase tracking-[0.18em] text-brandred" data-id="element-185" data-mp="7ktv6h5xub7w">
              🏆 Acceso hoy por
            </p>
            <p className="font-display text-[68px] leading-none font-black tracking-tight text-navy sm:text-7xl" data-id="element-186" data-mp="1w62cs3xa5dbq">
              $15
              <span className="align-top text-2xl font-black text-navy/50" data-id="element-187" data-mp="1s6jvdi4o3kdn"> USD</span>
            </p>
            <p className="mt-2 text-center text-[12px] font-semibold text-navy/55" data-id="element-188" data-mp="25xyd7lmu9fj4">
              Pago único · Sin suscripciones · Acceso de por vida
            </p>

            <ScarcityBar data-id="element-189" data-mp="2fts1u3du0zh9" />

            <div className="mt-6 w-full" data-id="element-190" data-mp="2ft034joxulmr">
              <CTAButton label="🔴 QUIERO LA RUTA ANTICOAGULACIÓN POR $15" sub="Acceso inmediato · Garantía de 7 días" data-id="element-191" data-mp="2avgq1n3z8ewe" />
            </div>

            <CountdownTimer data-id="element-192" data-mp="2osvlb8gwvgwa" />

            <ul className="mt-6 grid w-full max-w-md gap-2 sm:grid-cols-3" data-id="element-193" data-mp="2jvn1z4k116tg">
              {[{
              icon: GlobeIcon,
              text: 'Cambio de moneda automático a tu moneda local'
            }, {
              icon: ZapIcon,
              text: 'Acceso inmediato tras el pago'
            }, {
              icon: MonitorSmartphoneIcon,
              text: 'Compatible con cualquier dispositivo'
            }].map(({
              icon: Icon,
              text
            }) => <li key={text} className="flex items-start gap-2 rounded-xl border border-navy/10 bg-cream px-3 py-2.5" data-id="element-194" data-mp="vxm95nwcrb78">
                  <Icon className="mt-0.5 h-4 w-4 shrink-0 text-brandred" strokeWidth={2.5} data-id="element-195" data-mp="15wjrua73kaib" />
                  <span className="text-[11.5px] font-semibold leading-snug text-navy/70" data-id="element-196" data-mp="88t9phgiul7v">
                    {text}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <TransformCTA text="Quiero asegurar mi cupo por $15 antes de que suba" variant="dark" data-id="element-197" data-mp="i6h426a7tqpi" />
      </div>
    </section>;
}